import React from 'react';

interface FilterInputProps {
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const FilterInput: React.FC<FilterInputProps> = ({ value, onChange, placeholder, onKeyPress, disabled = false }) => {
  return (
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onKeyPress={onKeyPress}
      placeholder={placeholder}
      disabled={disabled}
      className="pl-8 pr-3 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 w-full"
    />
  );
};

export default React.memo(FilterInput);
